import ampInstance from '@omc/apm-upload';
import Cookies from 'js-cookie';
import globalData from './globalData';
import config from '@/common/config/config';
import { getCt, getNetWorkType } from './common';

const parser = require('ua-parser-js');

const getLocationData = () => {
  const locationData = {
    mLat: '',
    mLon: '',
    mCityName: ''
  };
  const locationDataStr: string = Cookies.get('locationData') || '';
  if (locationDataStr !== '') {
    try {
      const locationDataObj: any = JSON.parse(locationDataStr);
      locationData.mLat = locationDataObj.latitude;
      locationData.mLon = locationDataObj.longitude;
      locationData.mCityName = globalData.locationCityName;
    } catch (error) {
      locationData.mLat = '';
      locationData.mLon = '';
      locationData.mCityName = '';
    }
  }
  return locationData;
};

const ampHandlerInit = () => {
  try {
    const ua = parser(navigator.userAgent);
    const mClient: number = ua?.os?.name?.indexOf('ios') !== -1 ? 101 : 102;

    console.log('[app]apm init');
    ampInstance.init({
      uploadHost: config.APM_UPLOAD_HOST,
      staticProps: {
        mChannel: globalData.serviceName,
        mClientType: mClient,
        mDeviceManu: ua.device.model,
        mSysVersion: `${ua?.os?.name || ""} ${ua?.os?.version || ""}`,
        mAppVersion: globalData.version
      },
      dynamicProps: {
        meddyId: () => Cookies.get('wsid') || Cookies.get('sid') || '',
        sid: () => Cookies.get('wsid') || Cookies.get('sid') || '',
        tid: () => Cookies.get('tid') || '',
        ct: () => getCt(),
        locationData: getLocationData,
        netWorkType: getNetWorkType
      },
      requestSaveLimit: 0,
      allowUploadApiHost: {
        // local: 'localhost:3000',
        dev: 'api-dev.mcdchina.net',
        sit: 'api-sit.mcdchina.net',
        uat: 'api-uat.mcdchina.net',
        stg: 'api-stg.mcdchina.net',
        master: 'api.mcd.cn',
        master2: 'api2.mcd.cn'
      }
    });
  } catch (err) {
    console.log('[app ampHandlerInit err]', err);
  }
};

const getReqDataAndConfig = (requestConfig: Record<string, any>) => {
  if (!requestConfig?.data && !requestConfig?.params) {
    return {};
  }
  let data = requestConfig?.data || {};
  let params = requestConfig?.params || {};
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (error) {
      data = {};
      console.log('[app getReqDataAndConfig error]', error);
    }
  }
  if (typeof params === 'string') {
    try {
      params = JSON.parse(params);
    } catch (error) {
      params = {};
      console.log('[app getReqDataAndConfig error]', error);
    }
  }
  return { ...data, ...params };
};

const getRequestData = (requestConfig: any): any => {
  let result = {};
  try {
    result = {
      method: requestConfig?.method || '',
      header: requestConfig?.headers || '',
      timestamp: Number(requestConfig?.headers?.['request-timestamp'] || 0) || '',
      traceid: requestConfig?.headers?.['x-b3-traceid'] || '',
      href: window?.location?.href || '',
      url: requestConfig?.url || '',
      data: getReqDataAndConfig(requestConfig)
    };
  } catch (error) {
    console.log('[app getRequestData error]', error);
  }
  return result;
};

const getResponseData = (response: any): any => {
  return {
    data: response?.data || {},
    timestamp: Date.now()
  };
};

const getErrorData = (error: any, errorInfo: Record<string, any>) => {
  let result: any = {};
  try {
    result = {
      data: {
        ...errorInfo,
        message: error?.message || 'apiRequestError'
      },
      timestamp: Date.now()
    };
  } catch (error) {
    console.log('[app getErrorData error]', error);
  }
  return result;
};

const ErrorCode = {
  timeout: '-1001',
  unknown: '-1',
};

const getErrorCode = (error: any) => {
  if (!error) {
    return ErrorCode.unknown;
  }
  if (error?.code === 'ECONNABORTED' && error?.message?.indexOf('timeout') > -1) {
    return ErrorCode.timeout;
  }
  return ErrorCode.unknown;
};

const ampHandler = ampInstance;

export default ampHandler;

export { ampHandlerInit, getRequestData, getResponseData, getErrorData, getErrorCode };
